import Construction from "./Construction";
import Engineering from "./Engineering";
import Environment from "./Environment";
import Plant from "./Plant";
import Railway from "./Railway";
import "./Service.css";
const Service = () => {
    return ( 
        <>
            <h1 className="heading">Services</h1>
            <Railway />
            <Environment />
            <Construction />
            <Engineering />
            <Plant />
        </>
     );
}
 
export default Service;